var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Alert, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import useTranslate from '../../../../../localization/helpers';
import PublicPrivateToggle from '../../../../components/PublicPrivateToggle';
import AssetNameDropdown from './AssetNameDropdown';
import FolderModelAccordion from './FolderModelAccordion';
import AssetFolderIcon from '../../../../icons/components/asset-folder-icon';
var FolderUploadDialog = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, onConfirm = _a.onConfirm, assets = _a.assets, selectedAssetId = _a.selectedAssetId, folders = _a.folders, _d = _a.folderCount, folderCount = _d === void 0 ? 0 : _d, _e = _a.documentCount, documentCount = _e === void 0 ? 0 : _e, _f = _a.totalSize, totalSize = _f === void 0 ? '0 MB' : _f, onOpen = _a.onOpen, _g = _a.existingModelCount, existingModelCount = _g === void 0 ? 0 : _g, _h = _a.existingFileSizeMB, existingFileSizeMB = _h === void 0 ? 0 : _h;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var _j = __read(useState(selectedAssetId || ((_b = assets[0]) === null || _b === void 0 ? void 0 : _b.id) || ''), 2), selectedAsset = _j[0], setSelectedAsset = _j[1];
    var _k = __read(useState('name'), 2), selectedFieldType = _k[0], setSelectedFieldType = _k[1];
    var _l = __read(useState('Public'), 2), visibilityMode = _l[0], setVisibilityMode = _l[1];
    var _m = __read(useState(new Set()), 2), expandedFolders = _m[0], setExpandedFolders = _m[1];
    var _o = __read(useState(new Set()), 2), selectedFolders = _o[0], setSelectedFolders = _o[1];
    var _p = __read(useState(new Set()), 2), selectedFiles = _p[0], setSelectedFiles = _p[1];
    var _q = __read(useState({}), 2), fileVisibility = _q[0], setFileVisibility = _q[1];
    var handleToggleFolderExpanded = function (folderId) {
        setExpandedFolders(function (prev) {
            var newSet = new Set(prev);
            if (newSet.has(folderId)) {
                newSet.delete(folderId);
            }
            else {
                newSet.add(folderId);
            }
            return newSet;
        });
    };
    // Initialize file visibility and selection from folders
    useEffect(function () {
        var initialVisibility = {};
        var allFileIds = new Set();
        var allFolderIds = new Set();
        folders.forEach(function (folder) {
            allFolderIds.add(folder.id);
            folder.files.forEach(function (file) {
                initialVisibility[file.id] = file.isPublic;
                allFileIds.add(file.id);
            });
        });
        setFileVisibility(initialVisibility);
        // Select all files by default when dialog opens
        setSelectedFiles(allFileIds);
        setSelectedFolders(allFolderIds);
    }, [folders]);
    // Call onOpen when dialog opens
    useEffect(function () {
        if (open && onOpen) {
            onOpen();
        }
    }, [open, onOpen]);
    var handleToggleFolderSelect = function (folderId) {
        setSelectedFolders(function (prev) {
            var newSet = new Set(prev);
            if (newSet.has(folderId)) {
                newSet.delete(folderId);
                // Unselect all files in this folder
                var folder_1 = folders.find(function (f) { return f.id === folderId; });
                if (folder_1) {
                    setSelectedFiles(function (prevFiles) {
                        var newFiles = new Set(prevFiles);
                        folder_1.files.forEach(function (file) { return newFiles.delete(file.id); });
                        return newFiles;
                    });
                }
            }
            else {
                newSet.add(folderId);
                // Select all files in this folder
                var folder_2 = folders.find(function (f) { return f.id === folderId; });
                if (folder_2) {
                    setSelectedFiles(function (prevFiles) {
                        var newFiles = new Set(prevFiles);
                        folder_2.files.forEach(function (file) { return newFiles.add(file.id); });
                        return newFiles;
                    });
                }
            }
            return newSet;
        });
    };
    var handleFileToggleSelect = function (fileId) {
        setSelectedFiles(function (prev) {
            var newSet = new Set(prev);
            if (newSet.has(fileId)) {
                newSet.delete(fileId);
            }
            else {
                newSet.add(fileId);
            }
            return newSet;
        });
        // Check if all files in the folder are unselected, then unselect the folder
        setSelectedFolders(function (prevFolders) {
            var newFolders = new Set(prevFolders);
            folders.forEach(function (folder) {
                var folderHasFile = folder.files.some(function (file) { return file.id === fileId; });
                if (folderHasFile) {
                    // Check if all files in this folder will be unselected after this toggle
                    var updatedSelectedFiles_1 = new Set(selectedFiles);
                    if (updatedSelectedFiles_1.has(fileId)) {
                        updatedSelectedFiles_1.delete(fileId);
                    }
                    else {
                        updatedSelectedFiles_1.add(fileId);
                    }
                    var hasAnySelectedFiles = folder.files.some(function (file) {
                        return updatedSelectedFiles_1.has(file.id);
                    });
                    if (!hasAnySelectedFiles) {
                        newFolders.delete(folder.id);
                    }
                    else {
                        newFolders.add(folder.id);
                    }
                }
            });
            return newFolders;
        });
    };
    var handleFileToggleVisibility = function (fileId, isPublic) {
        var _a;
        setFileVisibility(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[fileId] = isPublic, _a)));
        });
        // Check if all files have the same visibility after this change
        updateVisibilityMode(__assign(__assign({}, fileVisibility), (_a = {}, _a[fileId] = isPublic, _a)));
    };
    // Update visibility mode toggle based on file visibility states
    var updateVisibilityMode = function (currentVisibility) {
        var allFileIds = folders.flatMap(function (f) { return f.files.map(function (file) { return file.id; }); });
        var visibilityValues = allFileIds.map(function (id) { return currentVisibility[id]; });
        var allPublic = visibilityValues.every(function (v) { return v === true; });
        var allPrivate = visibilityValues.every(function (v) { return v === false; });
        if (allPublic) {
            setVisibilityMode('Public');
        }
        else if (allPrivate) {
            setVisibilityMode('Private');
        }
        else {
            setVisibilityMode(null); // Mixed state
        }
    };
    // Handle global visibility toggle
    var handleVisibilityModeChange = function (newMode) {
        var isPublic = newMode === 'Public';
        // Update all files to the selected visibility
        var newVisibility = {};
        folders.forEach(function (folder) {
            folder.files.forEach(function (file) {
                newVisibility[file.id] = isPublic;
            });
        });
        setFileVisibility(newVisibility);
        setVisibilityMode(newMode);
    };
    var handleConfirm = function () {
        onConfirm(Array.from(selectedFiles), selectedFieldType, fileVisibility);
        onClose();
    };
    // Count total selected files
    var selectedFileCount = selectedFiles.size;
    // Count selected model numbers (folders with at least one selected file)
    var selectedModelCount = folders.filter(function (folder) {
        return folder.files.some(function (file) { return selectedFiles.has(file.id); });
    }).length;
    var maxModelCount = 10;
    var totalModelCount = existingModelCount + selectedModelCount;
    var exceedsMaxModelCount = totalModelCount > maxModelCount;
    var remainingModelSlots = Math.max(0, maxModelCount - existingModelCount);
    // Calculate selected size in KB
    var selectedSizeKB = folders
        .flatMap(function (f) { return f.files; })
        .filter(function (file) { return selectedFiles.has(file.id); })
        .reduce(function (total, file) {
        var size = parseFloat(file.fileSize.replace(/[^\d.]/g, ''));
        var unit = file.fileSize.includes('MB') ? 1024 : 1;
        return total + size * unit;
    }, 0);
    var selectedSizeMB = selectedSizeKB / 1024;
    var maxSizeMB = 100;
    var totalSizeMB = existingFileSizeMB + selectedSizeMB;
    var exceedsMaxSize = totalSizeMB > maxSizeMB;
    var remainingSizeMB = Math.max(0, maxSizeMB - existingFileSizeMB);
    var hasValidationError = exceedsMaxSize || exceedsMaxModelCount;
    var selectedSizeFormatted = selectedSizeKB >= 1024 ? "".concat(selectedSizeMB.toFixed(2), "MB") : "".concat(selectedSizeKB.toFixed(0), " KBs");
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: 'md', fullWidth: true, slotProps: {
            paper: {
                sx: {
                    borderRadius: '16px',
                    maxWidth: { xs: '100%', sm: '820px' }
                }
            }
        }, children: [_jsxs(DialogTitle, { sx: {
                    padding: '24px 12px 8px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    pr: 3
                }, children: [_jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '16px'
                        }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: '4px' }, children: [_jsx(IconButton, { size: 'Xs', onClick: onClose, color: 'primary', children: _jsx(ArrowLeft02Icon, {}) }), _jsx(Typography, { variant: 'h6', color: 'text.primary', children: translate('companies.folderUploadDialog.title') })] }), _jsx(IconButton, { size: 'small', onClick: onClose, sx: {
                                    width: 28,
                                    height: 28,
                                    padding: 0
                                }, children: _jsx(Icon, { icon: 'mingcute:close-line', width: 20, height: 20 }) })] }), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center', children: [_jsx(Box, { children: _jsx(AssetFolderIcon, { width: isXs ? 30 : 40, height: isXs ? 30 : 40, color1: '#ddb94d', color2: '#FFCF5C', color3: '#FFCF5C' }) }), _jsx(Box, { sx: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '8px',
                                    padding: '8px 16px',
                                    backgroundColor: '#F4F6F8',
                                    borderRadius: '12px',
                                    alignItems: 'center',
                                    width: '100%'
                                }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }, children: [_jsxs(Box, { sx: {
                                                display: 'flex',
                                                flexDirection: isXs ? 'column' : 'row',
                                                alignItems: isXs ? 'flex-start' : 'center',
                                                justifyContent: 'space-between',
                                                gap: '8px'
                                            }, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }, children: _jsxs(Typography, { sx: {
                                                            fontWeight: 500,
                                                            fontSize: 18,
                                                            color: '#161C24',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }, children: [_jsxs("span", { style: { color: theme.palette.text.secondary }, children: [translate('assets.matchingAssets.assetName'), ":"] }), ' ', (_c = assets.find(function (asset) { return asset.id === selectedAsset; })) === null || _c === void 0 ? void 0 : _c.name] }) }), _jsx(AssetNameDropdown, { value: selectedFieldType, options: [
                                                        { id: 'name', name: translate('common.name') },
                                                        { id: 'type', name: translate('assets.type') }
                                                    ], onChange: function (value) { return setSelectedFieldType(value); }, variant: 'outlined', size: 'small' })] }), _jsxs(Box, { sx: { display: 'flex', gap: '4px', mt: isXs ? 1 : 0 }, children: [_jsx(Badge, { sx: {
                                                        backgroundColor: '#DFE3E8',
                                                        borderRadius: '500px',
                                                        padding: '0px 6px',
                                                        height: 20,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }, children: _jsxs(Typography, { sx: {
                                                            fontWeight: 700,
                                                            fontSize: 12,
                                                            lineHeight: 1.667,
                                                            color: theme.palette.grey[800]
                                                        }, children: [folderCount, " ", translate('companies.folderUploadDialog.folders')] }) }), _jsx(Badge, { sx: {
                                                        backgroundColor: '#DFE3E8',
                                                        borderRadius: '500px',
                                                        padding: '0px 6px',
                                                        height: 20,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }, children: _jsxs(Typography, { sx: {
                                                            fontWeight: 700,
                                                            fontSize: 12,
                                                            lineHeight: 1.667,
                                                            color: theme.palette.grey[800]
                                                        }, children: [documentCount, " ", translate('companies.folderUploadDialog.documents')] }) }), _jsx(Badge, { sx: {
                                                        backgroundColor: '#DFE3E8',
                                                        borderRadius: '500px',
                                                        padding: '0px 6px',
                                                        height: 20,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }, children: _jsx(Typography, { sx: {
                                                            fontWeight: 700,
                                                            fontSize: 12,
                                                            lineHeight: 1.667,
                                                            color: theme.palette.grey[800]
                                                        }, children: totalSize }) })] })] }) })] }), _jsx(Divider, { style: { marginLeft: '57px', marginRight: '18px' } })] }), _jsx(DialogContent, { sx: {
                    padding: '8px 40px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    overflow: 'visible',
                    position: 'relative',
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        left: isXs ? 27 : 39,
                        top: isXs ? -44 : -27,
                        bottom: 0,
                        width: '2px',
                        borderLeft: '2px dashed #637381'
                    }
                }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '32px',
                        maxHeight: 'calc(100dvh - 400px)',
                        overflowY: 'auto',
                        gap: 2,
                        width: '100%'
                    }, children: [_jsx(PublicPrivateToggle, { value: visibilityMode, onChange: handleVisibilityModeChange, variant: 'inherit', size: isXs ? 'small' : 'large', firstLabel: translate('documents.allPublic'), secondLabel: translate('documents.allPrivate') }), _jsx(Alert, { variant: 'standard', severity: 'info', icon: _jsx(Icon, { icon: 'eva:info-fill' }), sx: {
                                alignItems: 'flex-start',
                                backgroundColor: '#CAFDF5',
                                '& .MuiAlert-message': {
                                    width: '100%'
                                }
                            }, children: _jsx(Typography, { variant: 'body2', sx: {
                                    color: '#003768'
                                }, children: translate(existingModelCount > 0 || existingFileSizeMB > 0
                                    ? 'companies.folderUploadDialog.infoMessageWithExisting'
                                    : 'companies.folderUploadDialog.infoMessage', {
                                    count: folderCount,
                                    remainingModels: remainingModelSlots,
                                    remainingSize: remainingSizeMB.toFixed(2)
                                }) }) }), _jsx(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: expandedFolders.size > 0 ? '20px' : 0,
                                pb: 0.5,
                                pr: 0.5
                            }, children: folders.map(function (folder, index) { return (_jsx(Box, { sx: {
                                    ml: 2,
                                    position: 'relative',
                                    '&:before': {
                                        content: '""',
                                        position: 'absolute',
                                        left: isXs ? -34 : -45,
                                        top: 28,
                                        width: isXs ? 43 : 60,
                                        borderTop: '2px dashed #637381',
                                        zIndex: 1
                                    }
                                    // '&:after':{
                                    //         content: '""',
                                    //         position: 'absolute',
                                    //         left: -16,
                                    //         top: 28,
                                    //         width: '2px',
                                    //         height: 'calc(100% - 28px)',
                                    //         borderTop: '2px dashed #637381'
                                    //       }
                                }, children: _jsx(FolderModelAccordion, { modelNumber: folder.modelNumber, size: folder.size, isXs: isXs, files: folder.files, isExpanded: expandedFolders.has(folder.id), isSelected: selectedFolders.has(folder.id), selectedFiles: selectedFiles, fileVisibility: fileVisibility, onToggleExpanded: function () { return handleToggleFolderExpanded(folder.id); }, onToggleSelect: function () { return handleToggleFolderSelect(folder.id); }, onFileToggleSelect: handleFileToggleSelect, onFileToggleVisibility: handleFileToggleVisibility }) }, folder.id)); }) })] }) }), _jsx(DialogActions, { sx: {
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: '12px'
                }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: isXs ? 'column' : 'row',
                        justifyContent: 'space-between',
                        alignItems: isXs ? 'stretch' : 'center',
                        gap: '12px'
                    }, children: [_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px' }, children: [_jsx(Typography, { variant: 'body2', color: 'text.secondary', children: translate('companies.folderUploadDialog.selectedCount', {
                                        count: selectedFileCount,
                                        size: selectedSizeFormatted
                                    }) }), exceedsMaxModelCount && (_jsx(Typography, { variant: 'caption', color: 'error', children: translate(existingModelCount > 0
                                        ? 'fileUpload.totalModelCountExceededErrorWithExisting'
                                        : 'fileUpload.totalModelCountExceededError', {
                                        remaining: remainingModelSlots
                                    }) })), exceedsMaxSize && (_jsx(Typography, { variant: 'caption', color: 'error', children: translate(existingFileSizeMB > 0
                                        ? 'fileUpload.totalFileSizeErrorWithExisting'
                                        : 'fileUpload.totalFileSizeError', {
                                        remaining: remainingSizeMB.toFixed(2)
                                    }) }))] }), _jsxs(Box, { sx: { display: 'flex', gap: '12px', justifyContent: isXs ? 'stretch' : 'flex-end' }, children: [_jsx(Button, { variant: 'outlined', color: 'inherit', size: 'medium', onClick: onClose, sx: { flex: isXs ? 1 : 'none' }, children: translate('actions.cancel') }), _jsx(Button, { variant: 'contained', color: 'inherit', size: 'medium', onClick: handleConfirm, disabled: hasValidationError, sx: { flex: isXs ? 1 : 'none' }, children: translate('actions.confirm') })] })] }) })] }));
};
export default FolderUploadDialog;
